var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "res-date-range-picker"
  }, [_vm.printRead ? [_c('span', {
    staticClass: "res-print-read m-l-5"
  }, [_vm._v(_vm._s(_vm.printReadStr))])] : [_vm.type === 'timerange' ? _c('el-time-picker', _vm._g(_vm._b({
    style: _vm.styleWidth,
    attrs: {
      "disabled": !_vm.edit || _vm.disabled,
      "popper-class": _vm.customClass,
      "is-range": ""
    },
    model: {
      value: _vm.dataModel,
      callback: function ($$v) {
        _vm.dataModel = $$v;
      },
      expression: "dataModel"
    }
  }, 'el-time-picker', { ..._vm.$attrs
  }, false), _vm.$listeners)) : [_c('el-date-picker', _vm._g(_vm._b({
    style: _vm.styleWidth,
    attrs: {
      "type": _vm.type,
      "disabled": !_vm.edit || _vm.disabled,
      "range-separator": _vm.rangeSeparator,
      "popper-class": _vm.customClass,
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: _vm.dataModel,
      callback: function ($$v) {
        _vm.dataModel = $$v;
      },
      expression: "dataModel"
    }
  }, 'el-date-picker', { ..._vm.$attrs
  }, false), _vm.$listeners))]], _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };